import { createSelector } from 'reselect';
export const selectListCosmeticHistory = createSelector(state => state.cosmeticHistory.data, state => state.cosmeticItemsConfigs.cosmeticConfigs, (data, cosmeticConfigs) => {
  return data.map(e => {
    const item = cosmeticConfigs === null || cosmeticConfigs === void 0 ? void 0 : cosmeticConfigs[e.typeId];
    return item ? { ...e,
      urlImage: item.urlImage,
      name: item.name
    } : e;
  });
});